import { Card, CardContent, Typography } from '@mui/material';
import tokens from '../styles/tokens';
import React from 'react';

const InfoDisplayCard = ({ variant = 'h2', infoList = [] }) => {
    return (
        <Card
            sx={{
                minWidth: 260,
                maxWidth: 560,
                margin: tokens.spacing.cardMargin,
                borderRadius: tokens.radius.md,
                border: `1px solid ${tokens.colors.border}`,
                background: tokens.colors.surface,
                boxShadow: tokens.colors.shadow
            }}
            elevation={0}
        >
            <CardContent sx={{ py: 2, px: 3 }}>
                {
                    infoList.map((item) => {
                        return (
                            <Typography key={item.key} variant={variant} sx={{ fontSize: 18, fontWeight: 600, mb: 0.5 }}>
                                {item.label} : <span style={{ color: item.color }}>{item.value}</span>
                            </Typography>
                        )
                    })
                }
                <Typography variant={'h5'} sx={{ fontSize: 16, color: tokens.colors.textMuted, mt: 0.5 }}>
                    {"All timestamps are in "}<span style={{color: "#006400"}}>{"UTC"}</span>
                </Typography>
            </CardContent>
        </Card>
    );
}

export default InfoDisplayCard;
